import React, { useState, useEffect, useRef } from "react";
import * as API from '../../../framework/API/api';
import { utility } from "../../../framework/utility/utilityProvider";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid, GridColumn, GridNoRecords, getSelectedState, GridToolbar } from '@progress/kendo-react-grid';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useTranslation } from "../../../locale/useTranslation";
import ToastNotification from "../../../components/ToastNotification";
import { COLUMNSTYPE, ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, LOGEVENT, MAM_STATUS, MODULE, PREFERENCE_ENTITYNAME, TOAST_TYPES, TRANSMISSION_ACTION, TRANSMISSION_ACTIVE_STATUS, VOD_ACTIVITY_REPORT_TYPE } from "../../../framework/constant/constant";
import ActionButton from "../../../framework/forms/helpercomponents/buttons/ActionButton";
import RoundButton from "../../../framework/forms/helpercomponents/buttons/RoundButton";
import MyStatusCell from "../../../components/MyStatusCell";
import MAMStatusCell from "../../../components/MAMStatusCell";
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from "../../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { TimeCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { ArrayCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { TransmissionTypeStatusCell } from "../../../components/TransmissionTypeStatusCell";
import moment from "moment";
import { MenuCommandCell } from '../../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import { collectionMenuModelVODReport } from "../../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel";
import { ContextMenu } from 'primereact/contextmenu';
import { UserPreference } from '../../userPreference/UserPreference';

const VODActivityReport = () => {

    const currentDate = Date.now();
    const previousDate = moment(new Date(currentDate)).subtract(1, 'days').format("YYYY-MM-DD");
    const lang = useTranslation();

    const [transmissionFilter, setTransmissionFilter] = useState({
        fromDate: previousDate,
        toDate: previousDate,
        mamStatus: { _id: null, Description: "All" },
        status: { _id: null, Description: "All" }
    });
    const [thumbnailFilter, setThumbnailFilter] = useState({
        fromDate: previousDate,
        toDate: previousDate
    });
    const [mamTxReadyFilter, setMamTxReadyFilter] = useState({
        fromDate: previousDate,
        toDate: previousDate
    });
    const [missingTransmissionFilter, setMissingTransmissionFilter] = useState({
        fromDate: previousDate,
        toDate: previousDate
    });
    const [missingPosterFilter, setMissingPosterFilter] = useState({
        isCatchUp: { _id: null, Description: "All" }
    });

    const [transmissionData, setTransmissionData] = useState([]);
    const [thumbnailData, setThumbnailData] = useState([]);
    const [mamTxReadyData, setMamTxReadyData] = useState([]);
    const [missingTransmissionData, setMissingTransmissionData] = useState([]);
    const [missingPosterData, setMissingPosterData] = useState([]);

    const [tabNumber, setTabNumber] = useState(String(VOD_ACTIVITY_REPORT_TYPE.Transmissions));
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [dataColumns, setDataColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);

    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const DATA_ITEM_KEY = '_id';
    const idGetter = (dataItem) => dataItem[DATA_ITEM_KEY];
    const menuRef = useRef(null);

    const onChangeTransmission = (e) => {
        const { name, value, type, checked } = e.target;
        setTransmissionFilter(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const onChangeThumbnail = (e) => {
        const { name, value, type, checked } = e.target;
        setThumbnailFilter(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const onChangeMamTxReady = (e) => {
        const { name, value, type, checked } = e.target;
        setMamTxReadyFilter(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const onChangeMissingTransmission = (e) => {
        const { name, value, type, checked } = e.target;
        setMissingTransmissionFilter(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const userData = utility.getValue(LOCALSTORAGE_KEY.userData);

    useEffect(() => {
        loadGridColumns();
    }, []);

    const loadGridColumns = async () => {
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(
            PREFERENCE_ENTITYNAME.vodActivityReport,
            currentUserId
        );
        if (!columns || !columns.length) {
            columns = await API.getFormData(
                ENTITYNAME.Transmissions,
                currentUserId
            );
        }
        setDataColumns(columns ?? []);
    };

    const handleTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    const onCloseUserPreference = async (isSaved) => {
        setShowPreferences(false);
        if (isSaved) {
            let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
            let columns = await API.getFormData(PREFERENCE_ENTITYNAME.vodActivityReport, currentUserId);
            if (!columns || !columns.length) {
                columns = await API.getFormData(ENTITYNAME.Transmissions, currentUserId);
            }
            setDataColumns(columns ?? []);
        }
    };

    const getFilterForTab = (reportType = tabNumber) => {
        const type = Number(reportType);
        switch (type) {
            case VOD_ACTIVITY_REPORT_TYPE.Thumbnails:
                return thumbnailFilter;
            case VOD_ACTIVITY_REPORT_TYPE.MAMTXReady:
                return mamTxReadyFilter;
            case VOD_ACTIVITY_REPORT_TYPE.MissingTransmission:
                return missingTransmissionFilter;
            case VOD_ACTIVITY_REPORT_TYPE.MissingPoster:
                return missingPosterFilter;
            case VOD_ACTIVITY_REPORT_TYPE.Transmissions:
            default:
                return transmissionFilter;
        }
    };

    const isValid = (reportType = tabNumber) => {
        const type = Number(reportType);
        if (type === VOD_ACTIVITY_REPORT_TYPE.MissingPoster) {
            return true;
        }
        const filter = getFilterForTab(reportType);
        if (!filter.fromDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (!filter.toDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (filter.toDate < filter.fromDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_grater_then_from_date_error_message });
            return false;
        }
        return true;
    };

    const loadData = async (reportType = tabNumber) => {
        const type = Number(reportType);
        if (!isValid(type)) return;
        setIsLoading(true);
        setLoadingStatus(lang.data_loading_error_message);

        switch (type) {
            case VOD_ACTIVITY_REPORT_TYPE.Transmissions: {
                let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
                let columns = await API.getFormData(PREFERENCE_ENTITYNAME.vodActivityReport, currentUserId);
                setDataColumns(columns ?? []);
                setTransmissionData([]);
                setSelectedItems([]);
                setSelectedState({});

                const payload = {
                    fromDate: transmissionFilter?.fromDate ? utility.convertStringDatetoMilliseconds(transmissionFilter.fromDate) : null,
                    toDate: transmissionFilter?.toDate ? utility.convertStringEndDateToMilliSeconds(transmissionFilter.toDate) : null,
                    isExport: false,
                    reportType: type,
                    mamStatus: transmissionFilter.mamStatus,
                    status: transmissionFilter.status
                };

                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    setTransmissionData(res.data ?? []);
                    setLoadingStatus(lang.no_record_found_error_message);
                } else {
                    setTransmissionData([]);
                    setSelectedItems([]);
                    setSelectedState({});
                    setLoadingStatus(lang.no_record_found_error_message);
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            case VOD_ACTIVITY_REPORT_TYPE.Thumbnails: {
                setThumbnailData([]);
                const payload = {
                    fromDate: thumbnailFilter?.fromDate ? utility.convertStringDatetoMilliseconds(thumbnailFilter.fromDate) : null,
                    toDate: thumbnailFilter?.toDate ? utility.convertStringEndDateToMilliSeconds(thumbnailFilter.toDate) : null,
                    isExport: false,
                    reportType: type
                };

                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    setThumbnailData(res.data ?? []);
                    setLoadingStatus(lang.no_record_found_error_message);
                } else {
                    setThumbnailData([]);
                    setLoadingStatus(lang.no_record_found_error_message);
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            case VOD_ACTIVITY_REPORT_TYPE.MAMTXReady: {
                setMamTxReadyData([]);
                const payload = {
                    fromDate: mamTxReadyFilter?.fromDate ? utility.convertStringDatetoMilliseconds(mamTxReadyFilter.fromDate) : null,
                    toDate: mamTxReadyFilter?.toDate ? utility.convertStringEndDateToMilliSeconds(mamTxReadyFilter.toDate) : null,
                    isExport: false,
                    reportType: type
                };

                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    setMamTxReadyData(res.data ?? []);
                    setLoadingStatus(lang.no_record_found_error_message);
                } else {
                    setMamTxReadyData([]);
                    setLoadingStatus(lang.no_record_found_error_message);
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            case VOD_ACTIVITY_REPORT_TYPE.MissingTransmission: {
                setMissingTransmissionData([]);
                const payload = {
                    fromDate: missingTransmissionFilter?.fromDate ? utility.convertStringDatetoMilliseconds(missingTransmissionFilter.fromDate) : null,
                    toDate: missingTransmissionFilter?.toDate ? utility.convertStringEndDateToMilliSeconds(missingTransmissionFilter.toDate) : null,
                    isExport: false,
                    reportType: type
                };

                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    setMissingTransmissionData(res.data ?? []);
                    setLoadingStatus(lang.no_record_found_error_message);
                } else {
                    setMissingTransmissionData([]);
                    setLoadingStatus(lang.no_record_found_error_message);
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            case VOD_ACTIVITY_REPORT_TYPE.MissingPoster: {
                setMissingPosterData([]);
                const payload = {
                    isExport: false,
                    isCatchUp: missingPosterFilter?.isCatchUp?._id !== undefined ? missingPosterFilter.isCatchUp._id : null,
                    reportType: type
                };

                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    setMissingPosterData(res.data ?? []);
                    setLoadingStatus(lang.no_record_found_error_message);
                } else {
                    setMissingPosterData([]);
                    setLoadingStatus(lang.no_record_found_error_message);
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            default:
                break;
        }

        setIsLoading(false);
    };

    const downloadExcel = async (reportType = tabNumber) => {
        const type = Number(reportType);
        if (!isValid(type)) return;
        setIsDownloading(true);

        let columns = dataColumns;
        if (!columns || columns.length === 0) {
            let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
            columns = await API.getFormData(PREFERENCE_ENTITYNAME.vodActivityReport, currentUserId);
            columns = columns ?? [];
            setDataColumns(columns);
        }

        switch (type) {
            case VOD_ACTIVITY_REPORT_TYPE.Transmissions: {
                const payload = {
                    fromDate: transmissionFilter?.fromDate ? utility.convertStringDatetoMilliseconds(transmissionFilter.fromDate) : null,
                    toDate: transmissionFilter?.toDate ? utility.convertStringEndDateToMilliSeconds(transmissionFilter.toDate) : null,
                    isExport: true,
                    reportType: type,
                    mamStatus: transmissionFilter?.mamStatus,
                    status: transmissionFilter.status,
                    columns: columns.map(col => ({ name: col.name, label: col.label, type: col.type, format: col.format }))
                };
                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            case VOD_ACTIVITY_REPORT_TYPE.Thumbnails: {
                const payload = {
                    fromDate: thumbnailFilter?.fromDate ? utility.convertStringDatetoMilliseconds(thumbnailFilter.fromDate) : null,
                    toDate: thumbnailFilter?.toDate ? utility.convertStringEndDateToMilliSeconds(thumbnailFilter.toDate) : null,
                    isExport: true,
                    reportType: type
                };
                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            case VOD_ACTIVITY_REPORT_TYPE.MAMTXReady: {
                const payload = {
                    fromDate: mamTxReadyFilter?.fromDate ? utility.convertStringDatetoMilliseconds(mamTxReadyFilter.fromDate) : null,
                    toDate: mamTxReadyFilter?.toDate ? utility.convertStringEndDateToMilliSeconds(mamTxReadyFilter.toDate) : null,
                    isExport: true,
                    reportType: type
                };
                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            case VOD_ACTIVITY_REPORT_TYPE.MissingTransmission: {
                const payload = {
                    fromDate: missingTransmissionFilter?.fromDate ? utility.convertStringDatetoMilliseconds(missingTransmissionFilter.fromDate) : null,
                    toDate: missingTransmissionFilter?.toDate ? utility.convertStringEndDateToMilliSeconds(missingTransmissionFilter.toDate) : null,
                    isExport: true,
                    reportType: type
                };
                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            case VOD_ACTIVITY_REPORT_TYPE.MissingPoster: {
                const payload = {
                    isExport: true,
                    isCatchUp: missingPosterFilter?.isCatchUp?._id !== undefined ? missingPosterFilter.isCatchUp._id : null,
                    reportType: type
                };
                const res = await API.getVodActivityReport(payload);
                if (res.success) {
                    window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
                break;
            }

            default:
                break;
        }

        setIsDownloading(false);
    };

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({ event, selectedState: selectedState, dataItemKey: DATA_ITEM_KEY });
        setSelectedState(newSelectedState);
        let items = transmissionData.filter((x) => newSelectedState[x._id] === true);
        setSelectedItems(items);
    };

    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);
        let items = checked ? transmissionData : [];
        setSelectedItems(items);
    };

    const markAsVerified = async (dataItems = []) => {
        const items = Array.isArray(dataItems) ? dataItems : [dataItems];
        const currentTime = new Date().getTime();

        const payload = items.map(item => ({
            _id: item._id,
            Verified: true,
            VerifiedBy: { _id: userData?._id ?? "", Name: userData?.name ?? userData?.Name ?? "" },
            VerifiedOn: currentTime
        }));

        let res = await API.saveData(ENTITYNAME.Transmissions, payload);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.marked_as_verified_success_message });
            const updatedIds = items.map(x => x._id);
            setTransmissionData(transmissionData.map(x => updatedIds.includes(x._id) ? { ...x, Verified: true, VerifiedBy: { _id: userData?._id ?? "", Name: userData?.name ?? userData?.Name ?? "" }, VerifiedOn: currentTime } : x));
            const updatedData = items.filter(x => updatedIds.includes(x._id));
            for (const item of updatedData) {
                item.Verified = true;
                item.VerifiedBy = { _id: userData?._id ?? "", Name: userData?.name ?? userData?.Name ?? "" };
                item.VerifiedOn = currentTime;
                let logData = { event: LOGEVENT.UPDATE_TRANSMISSION, module: MODULE.TRANSMISSION_BROWSER, data: item, message: "Transmission updated successfully" };
                await API.SaveLogs(logData);
            }
            setSelectedItems([]);
            setSelectedState({});
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    const resetVerifiedStatus = async (dataItems = []) => {
        const items = Array.isArray(dataItems) ? dataItems : [dataItems];
        const payload = items.map(item => ({
            _id: item._id,
            Verified: false,
            VerifiedBy: "",
            VerifiedOn: ""
        }));

        let res = await API.saveData(ENTITYNAME.Transmissions, payload);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.reset_verified_status_success_message });
            const updatedIds = items.map(x => x._id);
            setTransmissionData(transmissionData.map(x => updatedIds.includes(x._id) ? { ...x, Verified: false, VerifiedBy: "", VerifiedOn: "" } : x));
            let updatedData = items.filter(x => updatedIds.includes(x._id));
            for (const item of updatedData) {
                item.Verified = false;
                item.VerifiedBy = "";
                item.VerifiedOn = "";
                let logData = { event: LOGEVENT.UPDATE_TRANSMISSION, module: MODULE.TRANSMISSION_BROWSER, data: item, message: "Transmission updated successfully" };
                await API.SaveLogs(logData);
            }
            setSelectedItems([]);
            setSelectedState({});
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            myMenuModel={collectionMenuModelVODReport}
            markAsVerified={markAsVerified}
            resetVerifiedStatus={resetVerifiedStatus}
        />
    );

    const menuModel = [
        selectedItems.length > 1 && {
            label: lang.mark_as_verified_label,
            icon: 'pi pi-check-circle',
            command: () => markAsVerified(selectedItems)
        },
        selectedItems.length > 1 && {
            label: lang.reset_verified_status_label,
            icon: 'pi pi-times-circle',
            command: () => resetVerifiedStatus(selectedItems)
        }
    ].filter(Boolean);

    const actionStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(TRANSMISSION_ACTION, dataItem?.action);
        let tileBackColor = "";
        let titleColor = "white";

        switch (dataItem?.action) {
            case TRANSMISSION_ACTION.Published:
                tileBackColor = "#63AA43";
                break;
            case TRANSMISSION_ACTION.Delete:
                tileBackColor = "#E72929";
                break;
            case TRANSMISSION_ACTION.Create:
                tileBackColor = "#3B82F6";
                break;
            case TRANSMISSION_ACTION.Update:
                tileBackColor = "#F8A506";
                titleColor = "black";
                break;
            default:
                break;
        }
        return (<MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />);
    };

    const transmissionStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(TRANSMISSION_ACTIVE_STATUS, dataItem?.status);
        let tileBackColor = "";
        let titleColor = "white";
        switch (dataItem?.status) {
            case TRANSMISSION_ACTIVE_STATUS.Active:
                tileBackColor = "#63AA43";
                break;
            case TRANSMISSION_ACTIVE_STATUS.InActive:
                tileBackColor = "#E72929";
                break;
            case TRANSMISSION_ACTIVE_STATUS.Upcoming:
                tileBackColor = "#F8A506";
                titleColor = "black";
                break;
            default:
                break;
        }
        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />
        );
    };

    const thumbnailStatusCell = (props) => {
        const { dataItem } = props;
        const val = dataItem?.IsThumbnailProcessed ?? dataItem?.ThumbnailStatus ?? dataItem?.thumbnailStatus;
        let isProcessed = false;
        if (typeof val === 'boolean') {
            isProcessed = val;
        } else if (typeof val === 'number') {
            isProcessed = val === 1;
        } else if (typeof val === 'string') {
            isProcessed = val.toLowerCase() === 'processed' || val.toLowerCase() === 'true';
        }
        let title = isProcessed ? "Processed" : "Pending";
        let tileBackColor = isProcessed ? "#63AA43" : "#E72929";
        let titleColor = "white";

        return (<MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />);
    };

    const publishStatusCell = (props) => {
        const { dataItem } = props;
        const val = dataItem?.PublishStatus ?? dataItem?.publishStatus ?? dataItem?.status;
        let title = "";
        let tileBackColor = "";
        let titleColor = "white";

        if (typeof val === 'number') {
            title = utility.getKeyByValue(TRANSMISSION_ACTIVE_STATUS, val) || "";
        } else if (typeof val === 'string') {
            title = val;
        }

        const normalized = String(title).toLowerCase();
        if (normalized === 'active' || val === TRANSMISSION_ACTIVE_STATUS.Active) {
            tileBackColor = "#63AA43";
            title = "Active";
        } else if (normalized === 'inactive' || val === TRANSMISSION_ACTIVE_STATUS.InActive) {
            tileBackColor = "#E72929";
            title = "InActive";
        } else if (normalized === 'upcoming' || val === TRANSMISSION_ACTIVE_STATUS.Upcoming) {
            tileBackColor = "#F8A506";
            titleColor = "black";
            title = "Upcoming";
        } else if (title) {
            tileBackColor = "#727B84";
        }

        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />
        );
    };

    const mamHyperLinkCell = (props) => {
        const value = utility.getDataInsideObject(props.dataItem, props.field);
        return (
            <td>
                <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => window.open(`/home/mamAssets?mamID=${value}`, '_blank')}>{value}</div>
            </td>
        );
    };

    const workingTitleHyperLinkCell = (props) => {
        const value = utility.getDataInsideObject(props.dataItem, props.field) ?? props.dataItem?.WorkingTitle ?? props.dataItem?.workingTitle ?? props.dataItem?.title ?? "";
        return (
            <td title={value}>
                <div style={{ color: 'blue', cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => window.open(`/home/versionBrowser?searchtext=${value}`, '_blank')}>
                    {value}
                </div>
            </td>
        );
    };

    const verifiedStatusCell = (props) => {
        const { dataItem } = props;
        let title = dataItem?.Verified ? "Verified" : "Pending Verification";
        let tileBackColor = dataItem?.Verified ? "#63AA43" : "#727B84";
        let titleColor = "white";

        return (
            <MyStatusCell
                {...props}
                title={title}
                tileBackColor={tileBackColor}
                titleColor={titleColor}
            />
        );
    };

    const rowRender = (trElement, props) => {
        const isVerified = props.dataItem?.Verified;
        const isSelected = props.dataItem?.selected;

        if (isVerified && !isSelected) {
            const trChildren = React.Children.map(trElement.props.children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, {
                        style: {
                            ...(child.props?.style || {}),
                            backgroundColor: "#e8f5e9"
                        }
                    });
                }
                return child;
            });

            return React.cloneElement(
                trElement,
                {
                    ...trElement.props,
                    style: {
                        ...(trElement.props.style || {}),
                        backgroundColor: "#e8f5e9"
                    }
                },
                trChildren
            );
        }
        return trElement;
    };

    const renderDynamicColumns = (columns) => {
        return (columns || []).map((column, index) => {
            if (column.type === COLUMNSTYPE.date) {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        cell={DateOnlyCell}
                        title={column.label}
                        width={column.width ?? 200}
                        sortable={true}
                    />
                );
            } else if (column.type === COLUMNSTYPE.datetime) {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        cell={DateCell}
                        title={column.label}
                        width={column.width ?? 200}
                        sortable={true}
                    />
                );
            } else if (column.name.includes("Duration") || column.type === COLUMNSTYPE.time) {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        cell={TimeCell}
                        title={column.label}
                        width={column.width ?? 200}
                        sortable={true}
                    />
                );
            } else if (column.name === "SID") {
                return null;
            } else if (column.type === COLUMNSTYPE.array) {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        cell={ArrayCell}
                        title={column.label}
                        width={column.width ?? 200}
                        format={column.format ?? "Description"}
                        sortable={false}
                    />
                );
            } else if (column.type === COLUMNSTYPE.transmissionTypeStatus) {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        cell={TransmissionTypeStatusCell}
                        title={column.label}
                        width={column.width ?? 200}
                        sortable={false}
                    />
                );
            } else if (column.label === "Title") {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        title={column.label}
                        width={column.width ?? 200}
                        format={column.format}
                        sortable={false}
                    />
                );
            } else if (column.type === COLUMNSTYPE.mamStatus) {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        cell={MAMStatusCell}
                        title={column.label}
                        width={column.width ?? 200}
                        sortable={false}
                    />
                );
            } else if (column.type === COLUMNSTYPE.localdatetime) {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        cell={LocalDateTimeColumn}
                        title={column.label}
                        width={column.width ?? 200}
                        sortable={false}
                    />
                );
            } else if (column.label === "MAM ID") {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        title={column.label}
                        cell={mamHyperLinkCell}
                        width={column.width ?? 120}
                        sortable={false}
                    />
                );
            } else if (column.name === "status") {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        title={column.label}
                        cell={transmissionStatusCell}
                        width={column.width ?? 120}
                        sortable={false}
                    />
                );
            } else if (column.name === "action") {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        title={column.label}
                        cell={actionStatusCell}
                        width={column.width ?? 120}
                        sortable={false}
                    />
                );
            } else if (column.name === "IsThumbnailProcessed") {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        title={column.label}
                        cell={thumbnailStatusCell}
                        width={column.width ?? 130}
                        sortable={false}
                    />
                );
            } else if (column.name === "Verified") {
                return (
                    <GridColumn
                        key={column.name || index}
                        field={column.name}
                        title={column.label}
                        cell={verifiedStatusCell}
                        width={column.width ?? 130}
                        sortable={false}
                    />
                );
            } else {
                return (
                    column.type !== COLUMNSTYPE.hidden && (
                        <GridColumn
                            key={column.name || index}
                            field={column.name}
                            title={column.label}
                            width={column.width ?? 200}
                            sortable={true}
                        />
                    )
                );
            }
        });
    };

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.vod_activity_report_header}</span>
        </h1>
        <div className="row">
            <div className="col-12">
                <Box sx={{ width: "100%" }}>
                    <TabContext value={tabNumber}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <TabList onChange={handleTabChange} aria-label="vod activity report tabs">
                                <Tab label={`${lang.transmissions_label} (${transmissionData.length})`} value={String(VOD_ACTIVITY_REPORT_TYPE.Transmissions)} />
                                <Tab label={`${lang.thumbnails_label} (${thumbnailData.length})`} value={String(VOD_ACTIVITY_REPORT_TYPE.Thumbnails)} />
                                <Tab label={`${lang.mam_tx_ready_label || "MAM TX Ready"} (${mamTxReadyData.length})`} value={String(VOD_ACTIVITY_REPORT_TYPE.MAMTXReady)} />
                                <Tab label={`${lang.missing_transmission_label} (${missingTransmissionData.length})`} value={String(VOD_ACTIVITY_REPORT_TYPE.MissingTransmission)} />
                                <Tab label={`${lang.missing_poster_label} (${missingPosterData.length})`} value={String(VOD_ACTIVITY_REPORT_TYPE.MissingPoster)} />
                            </TabList>
                        </Box>
                        <TabPanel value={String(VOD_ACTIVITY_REPORT_TYPE.Transmissions)}>
                            <div className="row mb-2">
                                <div className="col-2">
                                    <label className="form-label">{lang.from_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="fromDate" value={transmissionFilter.fromDate} onChange={onChangeTransmission} />
                                </div>
                                <div className="col-2">
                                    <label className="form-label">{lang.to_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="toDate" value={transmissionFilter.toDate} onChange={onChangeTransmission} />
                                </div>
                                <div className="col-2">
                                    <label className="form-label">{lang.status_label || "Status"}</label>
                                    <DropDownList
                                        data={[
                                            { _id: null, Description: "All" },
                                            ...Object.keys(TRANSMISSION_ACTIVE_STATUS).map((key) => ({ _id: TRANSMISSION_ACTIVE_STATUS[key], Description: key }))
                                        ]}
                                        dataItemKey="_id"
                                        textField="Description"
                                        value={transmissionFilter.status}
                                        onChange={(e) => setTransmissionFilter(prev => ({ ...prev, status: e.target.value }))}
                                        name="status"
                                    />
                                </div>
                                <div className="col-2">
                                    <label className="form-label">{lang.mam_asset_status_column || "MAM Status"}</label>
                                    <DropDownList
                                        data={[
                                            { _id: null, Description: "All" },
                                            ...Object.keys(MAM_STATUS).map((key) => ({ _id: MAM_STATUS[key], Description: key }))
                                        ]}
                                        dataItemKey="_id"
                                        textField="Description"
                                        value={transmissionFilter.mamStatus}
                                        onChange={(e) => setTransmissionFilter(prev => ({ ...prev, mamStatus: e.target.value }))}
                                        name="mamStatus"
                                    />
                                </div>
                                <div className="col mt-4">
                                    <ActionButton name={lang.show_button_text} onClick={() => loadData(VOD_ACTIVITY_REPORT_TYPE.Transmissions)} isLoading={isLoading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.Transmissions} />
                                    <RoundButton icon='download' onClick={() => downloadExcel(VOD_ACTIVITY_REPORT_TYPE.Transmissions)} disabled={isDownloading} isLoading={isDownloading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.Transmissions} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                                    <RoundButton icon='gear' onClick={() => setShowPreferences(true)} style={{ marginLeft: '10px' }} title={lang.preference_button_tooltip} />
                                </div>
                            </div>
                            <Grid
                                style={{ height: 'calc(100vh - 290px)', overflow: 'auto' }}
                                resizable={true}
                                data={transmissionData.map(item => ({ ...item, selected: !!selectedState[item._id] }))}
                                selectedField="selected"
                                onSelectionChange={onSelectionChange}
                                onHeaderSelectionChange={onHeaderSelectionChange}
                                dataItemKey={DATA_ITEM_KEY}
                                rowRender={rowRender}
                            >
                                <GridNoRecords>{loadingStatus}</GridNoRecords>
                                {selectedItems?.length > 1 && <GridToolbar>
                                    <div className="d-flex">
                                        {selectedItems.length > 1 && (
                                            <div>
                                                <RoundButton icon="ellipsis-v" title={lang.context_menu_label} onClick={(e) => menuRef.current.show(e)} />
                                                <ContextMenu
                                                    ref={menuRef}
                                                    model={menuModel}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </GridToolbar>}
                                <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
                                <GridColumn
                                    field="selected"
                                    width="50px"
                                    headerSelectionValue={
                                        transmissionData.length > 0 && transmissionData.findIndex(item => !selectedState[item._id]) === -1
                                    }
                                    locked={true}
                                />
                                {renderDynamicColumns(dataColumns)}
                            </Grid>
                            {showPreferences && (
                                <UserPreference
                                    entityName={ENTITYNAME.Transmissions}
                                    preferenceColumnENntityName={PREFERENCE_ENTITYNAME.vodActivityReport}
                                    handleClose={onCloseUserPreference}
                                />
                            )}
                        </TabPanel>
                        <TabPanel value={String(VOD_ACTIVITY_REPORT_TYPE.Thumbnails)}>
                            <div className="row mb-2">
                                <div className="col-3">
                                    <label className="form-label">{lang.from_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="fromDate" value={thumbnailFilter.fromDate} onChange={onChangeThumbnail} />
                                </div>
                                <div className="col-3">
                                    <label className="form-label">{lang.to_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="toDate" value={thumbnailFilter.toDate} onChange={onChangeThumbnail} />
                                </div>
                                <div className="col mt-4">
                                    <ActionButton name={lang.show_button_text} onClick={() => loadData(VOD_ACTIVITY_REPORT_TYPE.Thumbnails)} isLoading={isLoading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.Thumbnails} />
                                    <RoundButton icon='download' onClick={() => downloadExcel(VOD_ACTIVITY_REPORT_TYPE.Thumbnails)} disabled={isDownloading} isLoading={isDownloading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.Thumbnails} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                                </div>
                            </div>
                            <Grid data={thumbnailData} style={{ height: 'calc(100vh - 290px)' }} resizable={true}>
                                <GridNoRecords>{loadingStatus}</GridNoRecords>
                                <GridColumn field="CSID" title={lang.transmission_id_column} width={"150"} />
                                <GridColumn field="title" title={lang.title_column} width={"180"} />
                                <GridColumn field="episodeNumber" title={lang.episode_number_label} width={"140"} />
                                <GridColumn field="contentId" title={lang.content_id_column} width={"150"} />
                                <GridColumn field="MamAssetId" title={lang.mamID_label} width={"150"} />
                                <GridColumn field="IsThumbnailProcessed" title={lang.thumbnail_status_column} width={"150"} cell={thumbnailStatusCell} />
                                <GridColumn field="thumbnailFilename" title={lang.thumbnail_filename_column} width={"220"} />
                                <GridColumn field="thumbnailProcessedOn" title={lang.thumbnail_process_on_column} width={"200"} />
                            </Grid>
                        </TabPanel>
                        <TabPanel value={String(VOD_ACTIVITY_REPORT_TYPE.MAMTXReady)}>
                            <div className="row mb-2">
                                <div className="col-3">
                                    <label className="form-label">{lang.from_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="fromDate" value={mamTxReadyFilter.fromDate} onChange={onChangeMamTxReady} />
                                </div>
                                <div className="col-3">
                                    <label className="form-label">{lang.to_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="toDate" value={mamTxReadyFilter.toDate} onChange={onChangeMamTxReady} />
                                </div>
                                <div className="col mt-4">
                                    <ActionButton name={lang.show_button_text} onClick={() => loadData(VOD_ACTIVITY_REPORT_TYPE.MAMTXReady)} isLoading={isLoading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.MAMTXReady} />
                                    <RoundButton icon='download' onClick={() => downloadExcel(VOD_ACTIVITY_REPORT_TYPE.MAMTXReady)} disabled={isDownloading} isLoading={isDownloading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.MAMTXReady} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                                </div>
                            </div>
                            <Grid data={mamTxReadyData} style={{ height: 'calc(100vh - 290px)' }} resizable={true}>
                                <GridNoRecords>{loadingStatus}</GridNoRecords>
                                <GridColumn field="WorkingTitle" title={lang.working_title_column} cell={workingTitleHyperLinkCell} />
                                <GridColumn field="Title" title={lang.title_column} width={"150"} />
                                <GridColumn field="EpisodeNumber" title={lang.episode_number_column} width={"120"} />
                                <GridColumn field="MamAssetId" title={lang.mamID_label} width={"150"} />
                                <GridColumn field="MamStatus" title={lang.mam_asset_status_column} cell={MAMStatusCell} width={"200"} />
                                <GridColumn field="TransmissionCount" title={lang.transmission_count_column} />
                            </Grid>
                        </TabPanel>
                        <TabPanel value={String(VOD_ACTIVITY_REPORT_TYPE.MissingTransmission)}>
                            <div className="row mb-2">
                                <div className="col-3">
                                    <label className="form-label">{lang.from_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="fromDate" value={missingTransmissionFilter.fromDate} onChange={onChangeMissingTransmission} />
                                </div>
                                <div className="col-3">
                                    <label className="form-label">{lang.to_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="toDate" value={missingTransmissionFilter.toDate} onChange={onChangeMissingTransmission} />
                                </div>
                                <div className="col mt-4">
                                    <ActionButton name={lang.show_button_text} onClick={() => loadData(VOD_ACTIVITY_REPORT_TYPE.MissingTransmission)} isLoading={isLoading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.MissingTransmission} />
                                    <RoundButton icon='download' onClick={() => downloadExcel(VOD_ACTIVITY_REPORT_TYPE.MissingTransmission)} disabled={isDownloading} isLoading={isDownloading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.MissingTransmission} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                                </div>
                            </div>
                            <Grid data={missingTransmissionData} style={{ height: 'calc(100vh - 290px)' }} resizable={true}>
                                <GridNoRecords>{loadingStatus}</GridNoRecords>
                                <GridColumn field="DealReference" title={lang.deal_reference_label} width={"150"} />
                                <GridColumn field="WorkingTitle" title={lang.working_title_column} cell={workingTitleHyperLinkCell} />
                                <GridColumn field="EpisodeNumber" title={lang.episode_number_column} width={"120"} />
                                <GridColumn field="PublishStartDate" title={lang.publish_start_date_label} cell={DateOnlyCell} width={"140"} />
                                <GridColumn field="PublishEndDate" title={lang.publish_end_date_label} cell={DateOnlyCell} width={"140"} />
                                <GridColumn field="MamAssetId" title={lang.mamID_label} width={"150"} />
                                <GridColumn field="MamStatus" title={lang.mam_asset_status_column} cell={MAMStatusCell} width={"170"} />
                                <GridColumn field="TransmissionCount" title={lang.transmission_count_column} width={"150"} />
                            </Grid>
                        </TabPanel>
                        <TabPanel value={String(VOD_ACTIVITY_REPORT_TYPE.MissingPoster)}>
                            <div className="row mb-2">
                                <div className="col-2">
                                    <label className="form-label">{lang.catchup_label || "Catchup"}</label>
                                    <DropDownList
                                        data={[
                                            { _id: null, Description: "All" },
                                            { _id: true, Description: "Catchup" },
                                            { _id: false, Description: "Not Catchup" }
                                        ]}
                                        dataItemKey="_id"
                                        textField="Description"
                                        value={missingPosterFilter.isCatchUp}
                                        onChange={(e) => setMissingPosterFilter(prev => ({ ...prev, isCatchUp: e.target.value }))}
                                        name="isCatchUp"
                                    />
                                </div>
                                <div className="col mt-4">
                                    <ActionButton name={lang.show_button_text} onClick={() => loadData(VOD_ACTIVITY_REPORT_TYPE.MissingPoster)} isLoading={isLoading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.MissingPoster} />
                                    <RoundButton icon='download' onClick={() => downloadExcel(VOD_ACTIVITY_REPORT_TYPE.MissingPoster)} disabled={isDownloading} isLoading={isDownloading && Number(tabNumber) === VOD_ACTIVITY_REPORT_TYPE.MissingPoster} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                                </div>
                            </div>
                            <Grid data={missingPosterData} style={{ height: 'calc(100vh - 290px)' }} resizable={true} rowRender={rowRender}>
                                <GridNoRecords>{loadingStatus}</GridNoRecords>
                                <GridColumn field="CSID" title={lang.transmission_id_column} width={"150"} />
                                <GridColumn field="WorkingTitle" title={lang.working_title_column} cell={workingTitleHyperLinkCell} width={"280"} />
                                <GridColumn field="mediaEpisode.Title" title={lang.title_label} width={"200"} />
                                <GridColumn field="mediaEpisode.EpisodeNumber" title={lang.episode_number_column} width={"120"} />
                                <GridColumn field="ContentID" title={lang.content_id_column} width={"150"} />
                                <GridColumn field="Nodes" title={lang.nodes_column} width={"180"} format="Name" cell={ArrayCell} />
                                <GridColumn field="Nodes" title={lang.node_ids_column} width={"180"} format="CSID" cell={ArrayCell} />
                                <GridColumn field="startDate" title={lang.start_date_column} cell={DateOnlyCell} width={"140"} />
                                <GridColumn field="endDate" title={lang.end_date_column} cell={DateOnlyCell} width={"140"} />
                                <GridColumn field="ThumbnailStatus" title={lang.thumbnail_status_column} width={"150"} cell={thumbnailStatusCell} />
                                <GridColumn field="PublishStatus" title={lang.publish_status_column} width={"150"} cell={publishStatusCell} />
                            </Grid>
                        </TabPanel>
                    </TabContext>
                </Box>
            </div>
        </div>
    </>);
};

export default VODActivityReport;